// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "." + {"12":"d9f47265","123":"5e06a7d1","195":"dbd6a014","808":"3d9ccca3"}[chunkId] + ".js";
};